import type { ErrorComponentProps } from '@tanstack/react-router'

export default function ErrorComp({ err }: { err: ErrorComponentProps }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 px-4">
      <div className="w-full max-w-md animate-[fadeIn_0.5s_ease-in-out] text-center">
        <div className="mb-8">
          <div className="text-primary mb-4 animate-bounce text-8xl font-bold">
            Error
          </div>
          <p className="mb-8 font-medium text-red-500">{err.error.message}</p>
        </div>

        <div className="space-y-4">
          <button
            type="button"
            onClick={() => window.history.back()}
            className="bg-primary hover:bg-primary/80 flex w-full transform items-center justify-center gap-2 rounded-lg px-6 py-3 font-semibold text-white transition-all duration-200 hover:scale-105"
          >
            ← Kembali ke Halaman Sebelumnya
          </button>
          <a
            href="/"
            className="border-primary text-primary hover:bg-primary/10 flex w-full items-center justify-center gap-2 rounded-lg border-2 bg-white px-6 py-3 font-semibold transition-colors duration-200"
          >
            🏠 Ke Halaman Utama
          </a>
        </div>

        <div className="mt-8 text-sm text-gray-500">
          Error Code:{' '}
          <span className="rounded bg-gray-100 px-2 py-1 font-mono">
            {err.error.name || 'UNKNOWN_ERROR'}
          </span>
        </div>
      </div>
    </div>
  )
}
